import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImageStyleFieldModel } from '../../../models/image-style-field.model';
import { DropdownFieldModel } from '../../../models/dropdown-field.model';
import { textStyleFontDropdownOptions } from '../../../models/text-style-font-dropdown-options.model';
import { textStyleFontSizeDropdownOptions } from '../../../models/text-style-font-size-dropdown-options.model';
import { ImageStyleModel } from '../../../models/image-style.model';
import { TextStyleFieldComponent } from '../../TextStyleField/text-style-field.component';
import { Style } from '../../../../Styles/models/style.model';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { BlockDisplayTypeEnum } from '../../../enums/block-display-type.enum';
import { AdvancedColorPickerFieldModel, captionTextColorConfig, backgroundColorConfig, borderConfig } from '@Common/PageBuilder/models/advanced-color-picker-field.model';


@Component({
    selector: 'agpr-image-style-field',
    templateUrl: './image-style-field.component.html',
    styleUrls: ['./image-style-field.component.scss'],
    standalone: false
})
export class ImageStyleFieldComponent extends TextStyleFieldComponent implements OnInit, OnChanges {

    @Input() declare value: ImageStyleModel;
    @Input() declare field: ImageStyleFieldModel;
    @Input() isCanvas: boolean = false; // only used for customizations tab

    @Output() changes: EventEmitter<ImageStyleModel> = new EventEmitter<ImageStyleModel>();

    borderColorField: AdvancedColorPickerFieldModel;

    readonly buttonTypes = ButtonTypesEnum;
    readonly blockDisplayTypeEnum = BlockDisplayTypeEnum;

    showCornerRadius: boolean = false;

    ngOnInit() {
        if ((this.block?.displayElement?.displayType === BlockDisplayTypeEnum.ONLINE) || this.isCanvas) {
            this.showCornerRadius = true;
        }
        if (this.block?.displayElement) {
            this.field.allowExpertMode = this.block?.displayElement?.displayType !== BlockDisplayTypeEnum.ONLINE;
        }

        if (this.field?.defaultStyleStateOptions?.length) {
            this.defaultStyleStateOptions = this.field.defaultStyleStateOptions;
        }

        if (!this.value) {
            this.value = new ImageStyleModel();
        }

        this.styleStateField = new DropdownFieldModel(
            null,
            'displayStyleState',
            'PageBuilder.styles.contentBlockStyle',
            '',
            this.defaultStyleStateOptions
        );
        this.updateStyleOptions();

        this.colorPickerField =  AdvancedColorPickerFieldModel.create(captionTextColorConfig(true));

        this.fontFamilyField = new DropdownFieldModel(
            null,
            'fontFamily',
            '',
            '',
            textStyleFontDropdownOptions,
            '',
            'TextStyle.fontFamily.label'
        );

        this.fontSizeField = new DropdownFieldModel(
            null,
            'fontSize',
            '',
            '',
            textStyleFontSizeDropdownOptions,
            '',
            'TextStyle.fontSize.label'
        );


        this.backgroundColorField = AdvancedColorPickerFieldModel.create(backgroundColorConfig(true));

        this.borderColorField =  AdvancedColorPickerFieldModel.create({
            ...borderConfig(true),
            label: 'PageBuilder.formField.styles.borderColor',
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('value')) {
            if (!this.value) {
                this.value = new ImageStyleModel();
            }

            if (!this.value.fontSize) {
                this.value.fontSize = this.field.defaults.fontSize;
            }
            if (!this.value.color) {
                this.value.color = this.field.defaults.fontColor;
            }
            if (this.value.bold === undefined) {
                this.value.bold = this.field.defaults.bold;
            }
            this.updateStyleOptions();
        }
    }

    protected updateStyleFromSavedStyle() {
        if (!this.value || !this.styles || !Number(this.value.styleState)) {
            return;
        }

        const savedStyle: Style = this.styles.find(x => x.id === this.value.styleState as number);
        if (!savedStyle) {
            // the list doesn't contain the id we're looking for, can't load it
            return;
        }
        const imageStyleModel = new ImageStyleModel(savedStyle.style);
        imageStyleModel.styleState = this.value.styleState;
        imageStyleModel.displayStyleState = this.value.displayStyleState;
        imageStyleModel.template = savedStyle.template;

        this.value = imageStyleModel;
    }
}
